export default __webpack_public_path__ + "static/etGgcFWY-2226e5d3fe38833000560f84f645bf06.svg";